import React from "react";
import { Container, Typography, Paper, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import PageIntro from "../components/pageintro";
import SplitDescription from "../components/splitdescription";
import WhyTecloqCards from "../components/whytecloqcards";
import ServicesGridCards from "../components/servicesgrid";
import TransformComponent from "../components/transformcomp";

const transformData = {
    heading: "Lets Discuss your idea and see what our team can do for you",
    content: "Tecloq is one of the top Angular Development Company in the US that can help you grow your business with intuitive applications and dynamic single-page web applications. Hire angular developers to create well-structured applications while providing the best angular development services.",
}
const whydata = [
    {
      src: "/assets/ProductEngineering/Angular/why1.gif",
      alt: "why1",
      title: "Domain-Specific Solutions",
      description:
        "For the past several years, the Tecloq front-end team has been developing custom web apps ranging from small-scale projects to enterprise-level commercial solutions.",
    },
    {
      src: "/assets/ProductEngineering/Angular/why2.gif",
      alt: "why1",
      title: "Front-End Development",
      description:
        "We design applications that are engaging, intuitive, and conversion-driven and provide customers with a consistent source of revenue while also providing enjoyment to users.",
    },
    {
      src: "/assets/AdvancedAI/DataScience/why3.gif",
      alt: "why1",
      title: "Custom Software Development",
      description:
        "We provide Angular web development services that are tailored to the individual needs of each customer, ensuring that their expectations are fulfilled and exceeded.",
    },
  ];
  

const servicedata = [
  {
    src: "/assets/ProductEngineering/Angular/c1.gif",
    alt: "text analysis",
    width: "58%",
    paddingTop: "3%",
    text: "Progressive Web App",
  },
  {
    src: "/assets/ProductEngineering/Angular/c2.gif",
    alt: "text analysis",
    width: "65%",
    paddingTop: "0%", // No padding specified at the top
    text: "Component Based Architecture",
  },
  {
    src: "/assets/ProductEngineering/Angular/c3.png",
    alt: "text analysis",
    width: "50%",
    paddingTop: "10%",
    text: "Cross Platform Solution",
  },
  {
    src: "/assets/AdvancedAI/DataScience/npl.gif",
    alt: "text analysis",
    width: "50%",
    paddingTop: "8%",
    text: "Out of the Box functionality",
  },
  {
    src: "/assets/AdvancedAI/TextAnalysis/filefolder.png",
    alt: "text analysis",
    width: "50%",
    paddingTop: "8%",
    text: "Two way data Binding",
  },
  {
    src: "/assets/ProductEngineering/Angular/c6.png",
    alt: "text analysis",
    width: "50%",
    paddingTop: "8%",
    text: "MVC Support",
  },
];

const Angular = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <PageIntro
        bg={"/assets/ProductEngineering/Angular/background.webp"}
        subheading={"Agile, Scalable, And Secure"}
        heading={"Angular Development Services"}
        desc={
          "Hire Our Top Angular Developers To Create Flexible And Interactive Web Designs And Applications."
        }
      />

      <SplitDescription
        heading1={
          "Innovative and Effective Solutions for a Wide Range of Business Demands"
        }
        content1={
          "For a quality-conscious delivery, the highest priority is placed on customer satisfaction. At Tecloq, we help organizations articulate and create evidence of success by increasing ROI on their big data investments."
        }
        img1={"/assets/AdvancedAI/DataScience/dataFiles.png"}
        heading2={"We are a passionate team of experienced professionals"}
        content2={
          "Tecloq offers Angular development services to companies of all sizes and types, including startups and established corporations. We use cutting-edge solutions and technology, as well as the most recent Angular versions. We create high-performance Angular web apps and employ the most up-to-date resources and tools to ensure agility in our services."
        }
        img2={"/assets/AdvancedAI/DataScience/pipeline.png"}
      />

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: { xs: "4%", md: "8%" }, // Smaller margin on mobile
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", md: "40px" }, // Smaller font size on mobile
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "2%", md: "3%" }, // Adjust padding for smaller screens
            textAlign: "center",
          }}
        >
          Our Capabilities
        </Typography>
      </Box>

      <ServicesGridCards data={servicedata} />

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: { xs: "10%", md: "6%" }, // Adjust margin for mobile
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", md: "40px" }, // Responsive font size
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "2%", md: "3%" }, // Adjust padding for mobile
            textAlign: "center",
          }}
        >
          Why Tecloq?
        </Typography>
      </Box>

      <WhyTecloqCards data={whydata} />
      <TransformComponent data={transformData}/>
      
    </Box>
  );
};

export default Angular;
